<template>
  <div >
    <div class="sub-title">
      {{ $t('referral_program.earn_together') }}
    </div>
    <article class="rule-article">
      <h5>{{ $t('referral_program.rules') }} : </h5>
      <span v-html="$t('referral_program.rules_detail')"/>
    </article>
    <article class="detail-article">
      <h5>{{ $t('referral_program.detail') }} : </h5>
      <span v-html="$t('referral_program.detail_explain')"/>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ReferralRules'
}
</script>

<style lang="scss" scoped>
article {
  color: #494949;
}
b {
  color: #373737;
}
.sub-title {
  font-family: Roboto;
  font-size: 19px;
  font-weight: bold;
  color: #373737;
  margin-bottom: 30px;
}
.rule-article {
  margin-bottom: 60px;
  font-size: 13px;
}
.detail-article {
  font-size: 13px;
  line-height: 1.69;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReferralProgram/components/ReferralRules.vue